module.exports = __webpack_public_path__ + "img/classes-today.88a5422c.svg";